var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause6 = function SvgIconPause6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M36.249 40.151h3.894V28.848h-3.894v11.303zm-7.392 0h3.894V28.848h-3.894v11.303zM34.5 0C15.446 0 0 15.446 0 34.5 0 53.554 15.446 69 34.5 69 53.554 69 69 53.554 69 34.5 69 15.446 53.554 0 34.5 0z"
  })));
};
export default SvgIconPause6;